/* eslint-disable prettier/prettier */
import { MyThunkResult } from 'store';

import { companyBillingRequest, companyBillingSuccessful, companyBillingError } from 'action-creators/companyBilling';
import { Company } from 'models/company';
import { Response } from 'models/response';

import { axiosConfig, profile } from '../api';

export const getCompanyBilling =
  (companyId: string): MyThunkResult<Promise<Company | undefined>> =>
  async (dispatch) => {
    try {
      
      dispatch(companyBillingRequest());

      const { data } = await profile.get<Response<Company>>(`/Company/${companyId}`, axiosConfig);

      dispatch(companyBillingSuccessful(data));

      return data.data;
    } catch (ex) {
      dispatch(companyBillingError(ex));
    }
  };
